import { InMemoryStorage } from "./InMemoryStorage";
import { StorageType } from "./types";

export function getBrowserStorage(type: StorageType): Storage {
  try {
    if (type === "local") {
      // eslint-disable-next-line @web-monorepo/no-browser-storage
      return window.localStorage;
    }
    if (type === "session") {
      // eslint-disable-next-line @web-monorepo/no-browser-storage
      return window.sessionStorage;
    }

    throw new Error("Unsupported storage type");
    // eslint-disable-next-line no-catch-all/no-catch-all
  } catch {
    /* empty */
  }

  // eslint-disable-next-line no-console
  console.warn(`${type} storage is disabled, using in-memory storage`);
  return new InMemoryStorage();
}
